import { AxiosInstance } from 'axios';

export class AbstractApiService {
  protected axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }
}
